import { BadgeVariant } from '@/components/ui/badge'
import { FinancialModelPolicies, FinancialModelSettingsStatus } from '@/feature/financial-model/api/types'

export type FinancialModelCardLabel = FinancialModelSettingsStatus | Extract<FinancialModelPolicies, 'locked' | 'optional'>

export const badgeStatusVariants = {
  done: `success`,
  in_progress: `warning`,
  not_started: `error`,
  locked: `disabled`,
  optional: `info`
} satisfies Record<FinancialModelCardLabel, BadgeVariant>
